import { request } from "../api/http";

export type RecipientKeyDirectoryItem = {
  recipientUserId: string;
  recipientKeyId: string;
  publicKeyBase64: string;
};

export async function fetchRecipientKeys(recipientUserIds: string[]) {
  const res = await request<{ ok?: boolean; items?: RecipientKeyDirectoryItem[] }>(
    "/e2ee/recipient-keys",
    {
      method: "POST",
      auth: true,
      body: { recipientUserIds },
    }
  );
  return (res?.items || []) as RecipientKeyDirectoryItem[];
}


export async function publishE2EEIdentityKey(input: {
  keyId: string;
  algorithm: string;
  publicKeyBase64: string;
}) {
  return request<any>("/e2ee/identity-keys", {
    method: "POST",
    auth: true,
    body: {
      keyId: input.keyId,
      algorithm: input.algorithm,
      publicKeyBase64: input.publicKeyBase64,
    },
  });
}
